import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { SectionHeading } from "@/components/SectionHeading";
import { Card, CardContent } from "@/components/ui/card";
import { fetchBlogs } from "@/lib/api";

export default function BlogPage({ content }) {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const isHindi = content.locale === "hi";

  useEffect(() => {
    fetchBlogs()
      .then((items) => setBlogs(items))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <SectionHeading eyebrow={isHindi ? "ब्लॉग" : "Blog"} title={content.blog.title} description={content.blog.description} />
      {loading ? (
        <p className="mt-10 text-sm text-stone-500" data-testid="blog-page-loading-state">
          {isHindi ? "लेख लोड हो रहे हैं..." : "Loading articles..."}
        </p>
      ) : (
        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          {blogs.map((blog) => (
            <Card key={blog.slug} className="rounded-[28px] border-stone-200 bg-white shadow-sm transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg">
              <CardContent className="space-y-4 p-6">
                <div className="flex flex-wrap gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary">
                  <span data-testid={`blog-page-category-${blog.slug}`}>{blog.category}</span>
                  <span data-testid={`blog-page-reading-time-${blog.slug}`}>{blog.reading_time}</span>
                </div>
                <h2 className="font-heading text-2xl font-semibold text-stone-900" data-testid={`blog-page-title-${blog.slug}`}>
                  {blog.title}
                </h2>
                <p className="text-sm leading-7 text-stone-600" data-testid={`blog-page-excerpt-${blog.slug}`}>
                  {blog.excerpt}
                </p>
                <Link to={`/blog/${blog.slug}`} className="inline-flex text-sm font-semibold text-primary" data-testid={`blog-page-link-${blog.slug}`}>
                  {content.ctas.readArticle}
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}